// extracted by mini-css-extract-plugin
module.exports = {"root":"Full_root__mFVZt","image":"Full_image__5l4kb"};